/* Shared account-size state.
   Single source of truth across Options planner, Strategy Analyser, and
   Risk Tools Position Sizer. Defaults to $10,000 on first use so risk
   calculations produce immediate, sensible results. User can override
   any time — value persists to localStorage `dt_account_size`. */
import { useEffect, useState } from "react";

const KEY = "dt_account_size";
const DEFAULT_ACCOUNT = 10000;

export function useAccountSize() {
  const [raw, setRaw] = useState(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (stored !== null && stored !== "") return stored;
      // Seed with the default so all cross-component consumers see the
      // same value immediately on first load.
      localStorage.setItem(KEY, String(DEFAULT_ACCOUNT));
      return String(DEFAULT_ACCOUNT);
    } catch { return String(DEFAULT_ACCOUNT); }
  });
  useEffect(() => {
    try {
      if (raw === "" || raw === null) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, String(raw));
    } catch { /* noop */ }
  }, [raw]);
  const n = parseFloat(raw);
  const account = Number.isFinite(n) && n > 0 ? n : 0;
  return { accountRaw: raw, setAccount: setRaw, account };
}

export function readAccountSize() {
  try {
    const v = parseFloat(localStorage.getItem(KEY) || "");
    return Number.isFinite(v) && v > 0 ? v : 0;
  } catch { return 0; }
}
